import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Report } from 'powerbi-client';

// This is a placeholder for your root state type.
// In your actual application, you would import this from your store configuration file.
// e.g., import type { RootState } from '../store';
interface RootState {
  pbiReport: PBIReportState;
}

/**
 * Defines the shape of the Power BI report state in the Redux store.
 */
export interface PBIReportState {
  report: Report | null;
}

const initialState: PBIReportState = {
  report: null,
};

const pbiReportSlice = createSlice({
  name: 'pbiReport',
  initialState,
  reducers: {
    /**
     * Action to set the report object in the state. Dispatch this once the report is loaded.
     *
     * NOTE: We return a new state object here instead of mutating the 'state' draft.
     * This is a workaround for the TypeScript error (TS2322: Type 'Report' is not assignable to type 'WritableDraft<Report>')
     * that occurs when assigning the non-plain 'Report' class instance directly to the Immer-proxied state draft.
     * Returning a new state object bypasses Immer's mutation tracking for this specific reducer, resolving the type conflict.
     */
    setReport(state, action: PayloadAction<Report>) {
      return {
        ...state,
        report: action.payload,
      };
    },
    /**
     * Action to clear the report object and reset the state.
     * This uses standard Immer mutation as it deals with a serializable value (null).
     */
    clearReport(state) {
      state.report = null;
    },
  },
});

// Export the action creators
export const { setReport, clearReport } = pbiReportSlice.actions;

// Export the reducer to be added to the store
export default pbiReportSlice;

// Export selectors for easy access to the state in your components
export const selectPBIReport = (state: RootState): Report | null => state.pbiReport?.report;
